import { WATER_TESTING_MAP_PIN_INFO_QUERY } from '../data-access/water-testing-map-pin-info'
import { BaseQuery } from './BaseQuery'
import {
  waterTestingMapPinInfo,
  waterTestingMapPinInfoVariables
} from '../data-access/__generated__/types'

export class WaterTestingMapPinInfoQuery extends BaseQuery<
  waterTestingMapPinInfo,
  waterTestingMapPinInfoVariables
> {
  query = WATER_TESTING_MAP_PIN_INFO_QUERY
}
